// Variables to store the reference of the function
let closeButtonHandler: (() => void) | null = null;
let windowClickHandler: ((e: Event) => void) | null = null;

export function showLoginModal(text?: string, callback?: () => void, subheader?: string) {
    const modalElement = document.querySelector('#tmplus-login-modal');
    if (modalElement) {
        const titleElement = modalElement.querySelector('#login-modal-title');
        if (titleElement) {
            if (text) {
                titleElement.innerHTML = `${text}`;
            } else {
                titleElement.innerHTML = 'Bem-vindo ao <span>Toda Matéria</span>';
            }
        }

        if (subheader) {
            const header = document.querySelector('.enem-paywall-header');
            if (header) {   
                const divElement = document.createElement('div');
                divElement.classList.add('enem-paywall-subheader');
                divElement.innerHTML = `${subheader}`;
                header.appendChild(divElement);
            }
        }

        modalElement.classList.add('tmplus-login-modal--show');

        window.addEventListener('click', (e) => {
            if (
                e.target === modalElement &&
                !(modalElement.closest('.enem-main-content') || (modalElement as HTMLElement).querySelector('.enem-main-content'))
            ) {
                hideLoginModal();
            }
        });

        const closeButton = modalElement.querySelector('.tmplus-login-modal__button--close');
        if (closeButton) {
            // Remove event listener anterior if exists
            if (closeButtonHandler) {
                closeButton.removeEventListener('click', closeButtonHandler);
            }

            // Add new event listener
            closeButtonHandler = () => {
                document.body.style.setProperty('overflow', 'auto', 'important');
                if (document.getElementsByClassName('enem-container')[0]) {
                    document.getElementsByClassName('enem-container')[0].classList.remove('enem-container--overlay');
                }

                hideLoginModal();
            };
            closeButton.addEventListener('click', closeButtonHandler);
        }

        if (callback) {
            modalElement.addEventListener('tmplus-login-modal-hidden', callback, {
                once: true,
            });
        }
    } else {
        throw new Error('Login modal element not found');
    }
}

export function hideLoginModal() {
    const modalElement = document.querySelector('#tmplus-login-modal');
    if (modalElement) {
        const closeButton = modalElement.querySelector('.tmplus-login-modal__button--close');
        if (closeButton) {
            closeButton.removeEventListener('click', () => {
                hideLoginModal();
            });
        }

        modalElement.classList.remove('tmplus-login-modal--show');

        // Remove the event listeners from modal
        const newModal = modalElement.cloneNode(true) as HTMLElement;
        if (modalElement.parentNode) {
            modalElement.parentNode.replaceChild(newModal, modalElement);
        }

        // send custom event
        const customEvent = new CustomEvent('tmplus-login-modal-hidden');
        modalElement.dispatchEvent(customEvent);

        window.removeEventListener('click', (e) => {
            if (e.target === modalElement) {
                hideLoginModal();
            }
        });
    }
}